<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h1>Mobile Application Development</h1>
        </div>
    </div>
</div>

<div class="service-details ptb-100">
    <div class="container">
        <div class="service-details-image">
            <img fetchpriority="high" src="assets/img/services-image/mobile applicaton dev mainArtboard 1.png"
                alt="Mobile application development service overview">
        </div>
        <div class="service-details-content">
            <h3>Reach your customers and the target audience anywhere anytime with the power of mobility</h3>
            <p> Release your
                own mobile application to stand out of the competition. If you desire to go mobile with your business or
                have the next big mobile idea we are here to support you make it a reality. We provide mobile
                application development solutions from custom platforms, aggregate networks and Augmented Reality(AR) /
                Virtual Reality(VR) applications to simple mobile tools harnessing the power of portability and
                integrated sensors. Whether you want to target android users or ios users we have the solutions for your
                business. Want to target a niche market? Not a problem. We know the mobile market and we are ready to
                guide you to harness the best out of it.</p>
            <!-- <h4>Core Development</h4>
            <p>No fake products and services. The customer is king, their lives and needs are the inspiration. But I
                must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I
                will give you a complete account of the system, and expound the actual teachings of the great explorer
                of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure
                itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally
                encounter consequences that are extremely painful.</p>
            <h4>Define Your Choices</h4>
            <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti
                atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident,
                similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum
                quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio
                cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est,
                omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus
                saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic.</p>
            <p>On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and
                demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the
                pain and trouble that are bound to ensue; and equal blame belongs to those who fail in their duty
                through weakness of will, which is the same as saying through shrinking from toil and pain. These cases
                are perfectly simple and easy to distinguish. In a free hour, when our power of choice is untrammelled
                and when nothing prevents our being able to do what we like best, every pleasure is to be welcomed and
                every pain avoided. But in certain circumstances and owing to the claims of duty or the obligations of
                business it will frequently occur that pleasures have to be repudiated and annoyances accepted. The wise
                man therefore always holds in these matters to this.</p>
            <div class="service-details-info">
                <div class="single-info-box">
                    <h4>Client</h4>
                    <span>James Anderson</span>
                </div>
                <div class="single-info-box">
                    <h4>Category</h4>
                    <span>Saas, Marketing</span>
                </div>
                <div class="single-info-box">
                    <h4>Date</h4>
                    <span>February 28, 2020</span>
                </div>
                <div class="single-info-box">
                    <h4>Share</h4>
                    <ul class="social">
                        <li><a target="_blank" href="#"><i class='bx bxl-linkedin'></i></a></li>
                        <li><a target="_blank" href="#"><i class='bx bxl-twitter'></i></a></li>
                        <li><a target="_blank" href="#"><i class='bx bxl-facebook'></i></a></li>
                        <li><a target="_blank" href="#"><i class='bx bxl-instagram'></i></a></li>
                    </ul>
                </div>
                <div class="single-info-box">
                    <a class="default-btn" href="#">Live Preview</a>
                </div>
            </div> -->
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <i class='bx bxs-badge-check'></i> Platforms and aggregate networks
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <i class='bx bxs-badge-check'></i> Android app development
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <i class='bx bxs-badge-check'></i> iOS Application Development
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <i class='bx bxs-badge-check'></i> Hybrid app development
                    </div>
                </div>
                
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <i class='bx bxs-badge-check'></i> AR/VR App development
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<!-- 
<section class="subscribe-area bg-f4f5fe">
    <div class="container">
        <div class="subscribe-content">
            <h2>We always try to be the best support to you as possible</h2>
            <form class="newsletter-form">
                <div class="row align-items-center">
                    <div class="col-lg-8 col-md-8">
                        <input type="email" class="input-newsletter" placeholder="hello@jexsa.com" name="EMAIL"
                            required>
                    </div>
                    <div class="col-lg-4 col-md-4">
                        <button type="submit"><i class="bx bxs-hot"></i> Subscribe Now</button>
                    </div>
                </div>
            </form>
            <div class="shape14"><img src="assets/img/shape/shape13.png" alt="image"></div>
            <div class="shape15"><img src="assets/img/shape/shape14.png" alt="image"></div>
            <div class="shape16"><img src="assets/img/shape/shape15.png" alt="image"></div>
            <div class="shape17"><img src="assets/img/shape/shape16.png" alt="image"></div>
            <div class="shape18"><img src="assets/img/shape/shape17.png" alt="image"></div>
        </div>
    </div>
</section> -->

<section class="free-trial-area ptb-100 bg-f4f5fe">
    <div class="container">
        <div class="free-trial-content">
            <h2>Have an app idea? Let’s bring it to life.</h2>
            <!-- <p>Qualify your leads & recognize the value of word your customer will love you</p> -->
            <a routerLink="/contact" class="default-btn"><i class="bx bxs-hot" aria-hidden="true"></i>Get in Touch<span></span></a>
        </div>
    </div>
    <!-- <div class="shape10"><img src="assets/img/shape/shape10.png" alt="image"></div>
    <div class="shape11"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape12"><img src="assets/img/shape/shape11.png" alt="image"></div>
    <div class="shape13"><img src="assets/img/shape/shape12.png" alt="image"></div> -->
</section>